import { createContext } from 'react';
import initialMyBrandsState from './initialMyBrandsState';

const MyBrandsContext = createContext(initialMyBrandsState);

export default MyBrandsContext;
